import { useSubscription } from '@apollo/client/react';
import { type SimpleStoreFragment, StoreUpdateDocument } from '@drycut/graphql';
import { useEffect } from 'react';

type Props = {
  callback?: (broadcast: SimpleStoreFragment) => void;
  slug: string;
};

export function useStorePubSub({ slug, callback }: Props) {
  const { data } = useSubscription(StoreUpdateDocument, { variables: { slug } });
  const broadcast: SimpleStoreFragment | undefined = data?.storeUpdate;

  useEffect(() => {
    if (broadcast) {
      // The callback is intentionally an imperative side effect.
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
      callback?.(broadcast);
    }
  }, [broadcast, callback]);
}
